import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import GroupEventsInterestForm from '@components/group-events-interest-form'
import useStyles from './results.styles'

export const NoResultsPage = ({ resultsString }) => {
  const classes = useStyles()
  return (
    <Box
      data-gtm-group-events-search-no-results={resultsString}
      className={classes.root}
      display="flex"
      flexDirection="column"
    >
      <Typography className={classes.text} variant="h5" component="h1">
        {!isEmpty(resultsString) ? `No ${resultsString}` : 'No Results'}
      </Typography>
      <Typography className={classes.text} variant="body1">
        Try expanding the search by adjusting the filters.
      </Typography>
      <a href="/things-to-do/search?reset=all" className={classes.link}>
        Reset all search filters
      </a>
      <Box
        display="flex"
        flexDirection="column"
        bgcolor="#F5F5F5"
        borderRadius={16}
        p={2.5}
        my={7}
      >
        <Typography variant="h6" align="center" gutterBottom>
          Get notified about new events near you!
        </Typography>
        <Typography className={classes.text} variant="body1">
          We’re adding new events every day.
          Sign up to recieve updates when new events launch in your area.
        </Typography>
        <GroupEventsInterestForm displayEventInterests={false} />
      </Box>
    </Box>
  )
}

NoResultsPage.propTypes = {
  resultsString: PropTypes.string,
}
